import { render, staticRenderFns } from "./PromoteDialog.vue?vue&type=template&id=b2bf7c1a"
import script from "./PromoteDialog.vue?vue&type=script&lang=js"
export * from "./PromoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports